import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Arkhein Sys in production!</p>
        <a
          className="App-link"
          href="https://www.arkheinclima.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          Arkhein Clima
        </a>
      </header>
    </div>
  );
}

export default App;
